import Block from "@/components/wrappers/block"
import classNames from "classnames"
import Checkmark from "@/components/common/icons/checkmark"

export default function FlowerfieldMunicipalities({ block }) {
  const goal = block.attrs.municipalities[0].meters * 1.2

  const headline = block.attrs?.headline ? block.attrs.headline : false

  const municipalities = block.attrs.municipalities ?? []

  return (
    <Block block={block} className="mx-auto">
      <h2 className="mb-4 lg:mb-16 text-center">{headline}</h2>
      {municipalities.slice(0, 10).map((municipality, index) => (
        <TopListItem
          name={municipality.name}
          meters={municipality.meters}
          index={index}
          key={index}
          goal={goal}
        />
      ))}
    </Block>
  )
}
const TopListItem = ({ name, meters, index, goal, selected = false }) => {
  return (
    <div className="flex mb-10 items-center">
      <div
        className={classNames(
          "w-14 h-14 rounded-full flex justify-center items-center mr-4 font-serif font-bold",
          selected ? "bg-white" : "bg-summer-green-23"
        )}>
        {selected && <Checkmark className="w-4 h-4" />}
        {!selected && <>{index + 1}</>}
      </div>
      <div className="flex flex-1 flex-col">
        <div className="font-serif text-xl">
          <span className="font-bold">{name}</span>{" "}
          {(meters / 1000).toLocaleString("sv-SE", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
          })}{" "}
          km
        </div>
        <div
          style={{
            width: (meters / goal) * 100 + "%",
            backgroundImage: "url(/flowerfields/bar.svg)"
          }}
          className="h-6"></div>
      </div>
    </div>
  )
}
